import React from 'react'
import { withRouter } from "react-router-dom";
import './index.css'
// @withRouter
class CommonFooter extends React.PureComponent {
    constructor() {
        super();
        this.clickHandle = this.clickHandle.bind(this);
        this.clickPic = this.clickPic.bind(this);
        this.state = {
            showCn: false,
            issn:'com'
        }
    }
    clickHandle(clickPage) {
        document.documentElement.scrollTop = document.body.scrollTop = 0;
        this.props.history.push(clickPage);
    }
    clickPic() {
        window.location.href = 'http://beian.miit.gov.cn';
    }
    componentDidMount(){
        this.isHasCn();
    }
    isHasCn(){
        let domainFlag = document.domain;
        if(domainFlag.indexOf('cn') > -1){
            this.setState({ showCn: true,issn:'cn' })
        }else{
            this.setState({ showCn: false,issn:'com' }) 
        }
    }
    render() {
        return (
            <div id="footerMobile">
                <div className="container_mobile" style={{"marginTop": 0}}>
                    <div className='footer-list'>
                        {/* <div className='pull-left text-left'>
                            <p className='sub-title'>52数学思维</p>
                            <p className='footer-sub-common click-page' onClick={() => this.clickHandle('/')}>首页</p>
                            <p className='footer-sub-common  click-page' onClick={() => this.clickHandle('/teacher/index')}>教研团队</p>
                            <p className='footer-sub-common  click-page' onClick={() => this.clickHandle('/problem/index')}>常见问题</p>
                            <p className='footer-sub-common  click-page' onClick={() => this.clickHandle('/software')}>软件下载</p>
                            <p className='footer-sub-common  click-page' onClick={() => this.clickHandle('/about')}>关于我们</p>
                        </div> */}
                        <div className='wrap'>
                            <div className='footer-sub-common underline'>举报和投诉</div>
                            <div className='footer-sub-common'>021-63178899&nbsp;&nbsp;&nbsp;13120811785</div>

                            <div className='footer-sub-common'>上海市静安区愚园路309号紫安大厦13F</div>
                            
                            <div className='footer-sub-common'>yang.yuan@fluxedu.com</div>

                            <div className='footer-sub-common'>微信服务号</div>
                            <div className='qrcode_wrap'><img className="qrcode" src={require('./qrcode.jpg')} alt="" /></div>
                        </div>
                        {/* <div className='pull-right text-right'>
                            <p className='sub-title'>微信服务号</p>
                            <p className='footer-sub-common'><img src={require('./qrcode.jpg')} alt="" /></p>
                        </div> */}
                    </div>
                </div>
                <div id="foot-wraper">
                    <div className="footer-common clearboth">Copyright © 2021 52数学思维  版权所有 www.52shuxue.{this.state.issn} All Rights Reserved </div>
                    <div className="footer-common clearboth licence">
                        <div><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">沪ICP备16005585号-3</a></div>
                        {/* 根据this.state.showCn判断，如果是true则显示第一种，如果是false显示第二种 */}
                        <a v-if={this.state.showCn} href="https://beian.mps.gov.cn/#/query/webSearch?code=31010602003868" target="_blank"><img src={require('./gh.png')}/>沪公网安备 31010602003868号</a>
                        <a v-else href="https://beian.mps.gov.cn/#/query/webSearch?code=31010602009522" target="_blank"><img src={require('./gh.png')}/>沪公网安备 31010602009522号</a>
                        {/* <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010602003868">沪公网安备 31010602003868号</a> */}
                        {/* <div><a href="https://tars.52shuxue.com/fluxedulicense/businesslicense.jpg" target="_blank">ICP经营许可证 沪B2-20200169</a></div> */}
                        {/* <div><a href="https://tars.52shuxue.com/fluxedulicense/broadcastinglicense.jpg" target="_blank">广播电视节目制作经营许可证(沪)字第03725号</a></div> */}
                    </div>
                </div>
            </div>
        )
    }

}
export default CommonFooter